import Vue from "vue";
import App from "./App.vue";
import router from "./plugins/router.js";
import "./plugins/element.js";
import axios from "./plugins/axios.js";
import qs from 'qs';
import utils from "./plugins/utils";
import i18n from "./plugins/i18n";

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$utils = utils;

new Vue({
    data() {
        return {
            service: "setting",
            user: {},
            services: [],
            menus: [],
        };
    },
    mounted() {
        let user = sessionStorage.getItem("user");
        if (user) {
            this.user = JSON.parse(user);
        }

        let services = sessionStorage.getItem("services");
        if (services) {
            this.services = JSON.parse(services);
        }

        let menus = sessionStorage.getItem("menus-setting");
        if (menus) {
            this.menus = JSON.parse(menus);
            this.addRoutes();
        }
    },
    methods: {
        loadUserInfo() {
            return new Promise(resolve => {
                this.$axios.get("/index/userinfo").then(response => {
                    if (response.data) {
                        this.user = response.data;
                        sessionStorage.setItem("user", JSON.stringify(response.data));
                    } else {
                        this.logOut();
                    }
                    resolve();
                });
            })
        },
        loadMenus() {
            return new Promise(resolve => {
                this.$axios.post("/index/menus").then((response) => {
                    let services = [];
                    response['data'].filter(item => {
                        if (this.user.type === 'SYSTEM') {
                            return item['parentId'] === 0 && item['serviceId'] === this.service;
                        } else {
                            return item['parentId'] === 0;
                        }
                    }).forEach(item => {
                        services.push(item);
                    });

                    this.services = services;
                    sessionStorage.setItem("services", JSON.stringify(this.services));

                    services.forEach(service => {
                        let menus = this.getChildMenus(response['data'], service['id']);
                        sessionStorage.setItem("menus-" + service['serviceId'], JSON.stringify(menus));

                        // 加载菜单和添加路由
                        if (service['serviceId'] === this.service) {
                            this.menus = menus;
                            this.addRoutes();
                        }
                    });
                    resolve();
                });
            })
        },
        getChildMenus(menus, pId) {
            let child = [];
            menus.forEach(menu => {
                if (menu['parentId'] === pId) {
                    child.push(menu);
                    Array.prototype.push.apply(child, this.getChildMenus(menus, menu['id']));
                }
            });
            return child;
        },
        addRoutes() {
            router.addRoutes([
                {
                    path: "/",
                    component: () => import("@/views/Index"),
                    children: this.getChildRoutes(),
                },
            ]);
        },
        getChildRoutes() {
            let routes = [];
            this.menus.forEach((menu) => {
                if (menu["path"]) {
                    let path = menu['path'];
                    let position = path.lastIndexOf("/") + 1;
                    let last = path.substring(position);

                    routes.push({
                        path: menu["path"],
                        component: () => import("./views" + path.substring(0, position) + last.charAt(0).toUpperCase() + last.slice(1) + ".vue"),
                    });
                }
            });
            return routes;
        },
        logOut() {
            this.$axios.post("/logout").then(() => {
                sessionStorage.clear();
                this.user = {};
                this.menus = [];

                this.$router.push("/login");
            });
        }
    },
    router,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
